#### Webhook subscription mutation split

It’s currently possible to update some config options of a webhook subscription, using the [`updateWebhookSubscriptionDeliveryConfiguration`] mutation.
Previously, this mutation required the `signingAlgorithmCode` as a mandatory string, which in turn required that `secret` was also provided, which meant that the secret string for webhook signing had to be included in every request to update a webhook subscription.
This made simple updates like changing the `maxAttemptsPerEvent` unnecessarily difficult.

To allow easier update actions, this mutation has been split in two.
To update `maxEventsPerAttempt` or `url`, continue to use the `updateWebhookSubscriptionDeliveryConfiguration` mutation as before.
To make changes to the signing config options, use the new [`updateWebhookSubscriptionSigningConfiguration`] mutation, which takes the `signingAlgorithmCode` and `secret` options.
Both mutations still return the full [`WebhookSubscription`].

##### New mutation examples

```graphql label="Update delivery config"
mutation updateWebhookDeliveryConfig(
  $webhookSubscriptionId: String!
  $url: String!
  $maxEventsPerAttempt: Int
) {
  updateWebhookSubscriptionDeliveryConfiguration(
    input: {
      webhookSubscription: {
        id: $webhookSubscriptionId
        url: $url
        maxEventsPerAttempt: $maxEventsPerAttempt
      }
    }
  ) {
    ... on UpdateWebhookSubscriptionDeliveryConfigurationPayload_Success {
      webhookSubscription {
        id {
          value
        }
        url
        maxEventsPerAttempt
      }
    }
    ... on UpdateWebhookSubscriptionDeliveryConfigurationPayload_Conflict {
      conflictingWebhookSubscription {
        id {
          value
        }
      }
    }
  }
}
```

```graphql label="Update signing config"
mutation updateWebhookSigningConfig(
  $webhookSubscriptionId: String!
  $signingAlgorithmCode: String!
  $secret: String
) {
  updateWebhookSubscriptionSigningConfiguration(
    input: {
      webhookSubscription: {
        id: $webhookSubscriptionId
        signingAlgorithmCode: $signingAlgorithmCode
        secret: $secret
      }
    }
  ) {
    webhookSubscription {
      id {
        value
      }
      signingAlgorithmCode
    }
  }
}
```

[`updatewebhooksubscriptiondeliveryconfiguration`]: /schema/mutation/updateWebhookSubscriptionDeliveryConfiguration
[`updatewebhooksubscriptionsigningconfiguration`]: /schema/mutation/updateWebhookSubscriptionSigningConfiguration
[`webhooksubscription`]: /schema/named-type/WebhookSubscription
